// frontend/src/components/Header.js
import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
    return (
        <header style={headerStyle}>
            <h1 style={titleStyle}>Unfamiliar Learning</h1>
            <nav>
                <Link to="/" style={linkStyle}>Home</Link>
                <Link to="/about" style={linkStyle}>About</Link>
                <Link to="/donate" style={linkStyle}>Donate</Link>
            </nav>
        </header>
    );
};

const headerStyle = {
    background: '#006400',
    color: '#FFFFFF',
    padding: '30px 0',
    textAlign: 'center',
    position: 'sticky',
    top: '0',
    zIndex: '1000',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)'
};

const titleStyle = {
    fontSize: '40px',        // Larger and more prominent
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: '2px',
    color: '#FFFFFF',
    marginBottom: '15px',
    opacity: 1,              // Ensure no transparency
};

const linkStyle = {
    margin: '0 20px',
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#FFFFFF',
    transition: 'color 0.3s ease'
};

export default Header;